<template>
  <validation-provider
    name="shipment"
    rules="required"
    v-slot="{ errors }">
    <div
      :class="{
        'form-control': true,
        'is-select': true,
        'is-invalid': errors.length,
        'vs-wrap-text': true
      }">
      <v-select
        :options="shippingMethods"
        v-model="shipment_id"
        :disabled="disabled"
        :reduce="(method) => method.id"
        placeholder="Wybierz metodę dostawy"
        :searchable="true"
        label="name">
      </v-select>
    </div>
    <div class="invalid-feedback">
      {{ errors[0] }}
    </div>
  </validation-provider>
</template>

<script>
import FormUtils from './../../../utils/FormUtils';
import CustomDecimals from './../../../utils/CustomDecimals.js';
import Vue from 'vue';

export default {
  name: 'order-shipping-select',
  props: [
    'disabled'
  ],
  data () {
    return {
      shipment_id: null,
      shippingMethods: [],
      loadError: false
    }
  },
  watch: {
    shipment_id (newValue) {
      if (newValue !== 0 && newValue !== null) {
        let shippingData = this.shippingMethods.filter(shipping => shipping.id === newValue);

        if (!shippingData[0]) {
          this.shipment_id = null;
        }
      }

      Vue.nextTick(() => {
        this.$bus.$emit('order-update-shipment-cost', this.getShippingCost());
      });
    }
  },
  mounted () {
    this.loadShippingData();
  },
  methods: {
    loadShippingData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/shipments/items',
        method: 'get',
        outputKey: 'shippingMethods',
        loadedKey: 'loaded',
        errorKey: 'loadError',
        successAction: () => {
          this.$bus.$emit('order-data-loaded', 'shipping');
          Vue.nextTick(() => {
            if (this.shippingMethods.length === 1) {
              this.shipment_id = this.shippingMethods[0].id;
            }
          });
        }
      });
    },
    setShipmentID (shipmentID = null) {
      Vue.set(this, 'shipment_id', shipmentID);
    },
    getShippingCost () {
      if (!this.shipment_id) {
        return 0;
      }

      let shippingData = this.shippingMethods.filter(shipping => shipping.id === this.shipment_id);

      if (shippingData[0]) {
        return this.roundProperly(shippingData[0].price);
      }

      return 0;
    },
    roundProperly (value, decimals = 2) {
      return CustomDecimals.roundProperly(value, decimals);
    }
  }
}
</script>
